/**
 * Modal
 *
 * Reusable screen overlay with modal content
 */
import { createComponent } from "react-fela";
import { expand, fluid } from "~/styleguide/utils";
import { colors, gutters } from "~/styleguide";
import React from "react";
import ReactDOM from "react-dom";

import Icon from "~/components/shared/icon";

const Modal = ({ isShowing, hide, children, centered }) =>
    isShowing
        ? ReactDOM.createPortal(
              <React.Fragment>
                  {/* Modal container */}
                  <Container
                      className="modal-wrapper"
                      aria-modal
                      aria-hidden
                      tabIndex={-1}
                      role="dialog"
                  >
                      {/* Dark modal screen. Can click to close */}
                      <Overlay onClick={hide} />

                      <CloseButton
                          type="button"
                          data-dismiss="modal"
                          aria-label="Close"
                          onClick={hide}
                      >
                          <Icon name="close" />
                      </CloseButton>

                      <Content centered={centered}>{children}</Content>
                  </Container>
              </React.Fragment>,
              document.body
          )
        : null;

export default Modal;

const Overlay = createComponent(
    () => ({
        ...expand("rgba(0,0,0,0.9)")
    }),
    "div",
    ["onClick"]
);

const Container = createComponent(() => ({
    ...expand(),
    position: "fixed",
    zIndex: 100
}));

const Content = createComponent(({ centered }) => ({
    zIndex: 101,
    position: "relative",
    maxWidth: 1200,
    marginH: "auto",
    top: "10vh",

    extend: [
        fluid("paddingH", gutters.default),
        {
            condition: centered,
            style: {
                position: "absolute",
                top: "50%",
                left: "50%",
                width: "100%",
                transform: "translate(-50%, -50%)"
            }
        }
    ]
}));

const CloseButton = createComponent(
    () => ({
        position: "absolute",
        appearance: "none",
        color: colors.white,
        background: "transparent",
        border: "none",
        padding: 0,
        cursor: "pointer",
        transition: "transform 0.2s ease, color 0.2s ease",
        willChange: "transform, color",
        outline: 0,
        whenActive: {
            color: colors.blue,
            transform: "scale(1.1)"
        },

        extend: [
            fluid("right", { max: 40, min: 10 }),
            fluid("top", { max: 40, min: 10 }),
            fluid("font-size", { max: 36, min: 24 })
        ]
    }),
    "button",
    ["type", "data-dismiss", "aria-label", "onClick"]
);
